export const componentesOperaciones = [{
    "Titulo": "Nuevas incorporaciones",
    "Data": [
      {
        "Titulo": "Nuestra empresa",
        "Categoria": "Formación corporativa",
        "Url": "https://www.google.com"
      },
      {
        "Titulo": "Estructura de operaciones",
        "Categoria": "Formación corporativa",
        "Url": "https://www.google.com"
      },
      {
        "Titulo": "El seguro/conceptos básicos",
        "Categoria": "Formación corporativa",
        "Url": "https://www.google.com"
      },
      {
        "Titulo": "Ley de protección de datos",
        "Categoria": "Formación corporativa",
        "Url": "https://www.google.com"
      },
      {
        "Titulo": "Prevención de blanqueo de capitales",
        "Categoria": "Formación corporativa",
        "Url": "https://www.google.com"
      },
      {
        "Titulo": "Prevención de riesgos laborales",
        "Categoria": "Formación corporativa",
        "Url": "https://www.google.com"
      },
      {
        "Titulo": "Ley de contrato de seguro",
        "Categoria": "Formación corporativa",
        "Url": "https://www.google.com"
      },
      {
        "Titulo": "Bases y fundamentos",
        "Categoria": "Formación corporativa",
        "Url": "https://www.google.com"
      },
      {
        "Titulo": "Mi proceso formativo",
        "Categoria": "Formación corporativa",
        "Url": "https://www.google.com"
      },
      {
        "Titulo": "Detalle",
        "Categoria": "Formación corporativa",
        "Url": "https://www.google.com"
      }
    ]
  }, {
    "Titulo": "Noticias",
    "Data": [
      {
        "Titulo": "Próxima acción formativa en Operaciones",
        "Categoria": "Noticias",
        "Url": "https://www.google.com"
      }
    ]
  }, {
    "Titulo": "Técnicas y habilidades",
    "Data": [
      {
        "Titulo": "Píldora de negociación",
        "Categoria": "Técnicas y habilidades",
        "Url": "https://www.google.com"
      },
      {
        "Titulo": "Tutorial de proactividad",
        "Categoria": "Técnicas y habilidades",
        "Url": "https://www.google.com"
      },
      {
        "Titulo": "Atención al cliente",
        "Categoria": "Técnicas y habilidades",
        "Url": "https://www.google.com"
      },
      {
        "Titulo": "Escritura eficaz",
        "Categoria": "Técnicas y habilidades",
        "Url": "https://www.google.com"
      },
      {
        "Titulo": "Redactando en la empresa",
        "Categoria": "Técnicas y habilidades",
        "Url": "https://www.google.com"
      }
    ]
  }, {
    "Titulo": "Banco de recursos",
    "Data": [
      {
        "Titulo": "Modelo C3",
        "Categoria": "Banco de recursos",
        "Url": "https://www.google.com"
      },
      {
        "Titulo": "Pautas en la comunicación",
        "Categoria": "Banco de recursos",
        "Url": "https://www.google.com"
      },
      {
        "Titulo": "Plantillas - Administración",
        "Categoria": "Banco de recursos",
        "Url": "https://www.google.com"
      },
      {
        "Titulo": "Plantillas - C.O.Agencial",
        "Categoria": "Banco de recursos",
        "Url": "https://www.google.com"
      },
      {
        "Titulo": "Plantillas - C.O.Producción diferida",
        "Categoria": "Banco de recursos",
        "Url": "https://www.google.com"
      },
      {
        "Titulo": "Creación plantillas Outllook",
        "Categoria": "Banco de recursos",
        "Url": "https://www.google.com"
      },
      {
        "Titulo": "Curso básico de Office 2010",
        "Categoria": "Banco de recursos",
        "Url": "https://www.google.com"
      },
      {
        "Titulo": "Curso avanzado de Office 2010",
        "Categoria": "Banco de recursos",
        "Url": "https://www.google.com"
      }
    ]
  }, {
    "Titulo": "Gestión de procedimientos",
    "Data": [
      {
        "Titulo": "Funciones y misión",
        "Categoria": "C.O. Producción diferida",
        "Url": "https://www.google.com"
      },
      {
        "Titulo": "Producción Nexus",
        "Categoria": "C.O. Producción diferida",
        "Url": "https://www.google.com"
      },
      {
        "Titulo": "Producción Nexus supeditadas",
        "Categoria": "C.O. Producción diferida",
        "Url": "https://www.google.com"
      },
      {
        "Titulo": "Producción no Nexus",
        "Categoria": "C.O. Producción diferida",
        "Url": "https://www.google.com"
      },
      {
        "Titulo": "Otras tareas",
        "Categoria": "C.O. Producción diferida",
        "Url": "https://www.google.com"
      },
      {
        "Titulo": "Funciones y misión",
        "Categoria": "C.O. Red Agencial",
        "Url": "https://www.google.com"
      },
      {
        "Titulo": "Aplicativo Centro Operativo",
        "Categoria": "C.O. Red Agencial",
        "Url": "https://www.google.com"
      },
      {
        "Titulo": "Modelo de Agencia",
        "Categoria": "C.O. Red Agencial",
        "Url": "https://www.google.com"
      },
      {
        "Titulo": "Control pagos/archivo",
        "Categoria": "C.O. Red Agencial",
        "Url": "https://www.google.com"
      },
      {
        "Titulo": "Financiero",
        "Categoria": "C.O. Red Agencial",
        "Url": "https://www.google.com"
      },
      {
        "Titulo": "Formación",
        "Categoria": "C.O. Red Agencial",
        "Url": "https://www.google.com"
      },
      {
        "Titulo": "Otros procedimientos",
        "Categoria": "C.O. Red Agencial",
        "Url": "https://www.google.com"
      },
      {
        "Titulo": "Funciones y misión",
        "Categoria": "C.O. Red Corredores",
        "Url": "https://www.google.com"
      },
      {
        "Titulo": "Flotas",
        "Categoria": "C.O. Red Corredores",
        "Url": "https://www.google.com"
      },
      {
        "Titulo": "Acuerdos especiales",
        "Categoria": "C.O. Red Corredores",
        "Url": "https://www.google.com"
      },
      {
        "Titulo": "Tutelas",
        "Categoria": "C.O. Red Corredores",
        "Url": "https://www.google.com"
      },
      {
        "Titulo": "Otras tareas",
        "Categoria": "C.O. Red Corredores",
        "Url": "https://www.google.com"
      },
      {
        "Titulo": "Comunicaciones a responsables comerciales",
        "Categoria": "Procedimientos comunes OPERACIONES",
        "Url": "https://www.google.com"
      },
      {
        "Titulo": "Documentos comunes",
        "Categoria": "Procedimientos comunes OPERACIONES",
        "Url": "https://www.google.com"
      },
      {
        "Titulo": "Procedimientos",
        "Categoria": "Procedimientos comunes OPERACIONES",
        "Url": "https://www.google.com"
      },
      {
        "Titulo": "Protocolos de atención al cliente",
        "Categoria": "Procedimientos comunes OPERACIONES",
        "Url": "https://www.google.com"
      },
      {
        "Titulo": "Atención a clientes asistencia sanitaria GCO",
        "Categoria": "Procedimientos comunes OPERACIONES",
        "Url": "https://www.google.com"
      },
      {
        "Titulo": "Actuaciones del Contact Center",
        "Categoria": "Procedimientos comunes OPERACIONES",
        "Url": "https://www.google.com"
      },
      {
        "Titulo": "Red Sucursales",
        "Categoria": "Procedimientos comunes OPERACIONES",
        "Url": "https://www.google.com"
      },
      {
        "Titulo": "Procedimientos Red Sucursales",
        "Categoria": "Procedimientos comunes OPERACIONES",
        "Url": "https://www.google.com"
      },
      {
        "Titulo": "Procedimientos Prestaciones Vida",
        "Categoria": "Procedimientos comunes OPERACIONES",
        "Url": "https://www.google.com"
      },
      {
        "Titulo": "Reinversiones Vida",
        "Categoria": "Procedimientos comunes OPERACIONES",
        "Url": "https://www.google.com"
      },
      {
        "Titulo": "Notas internas extornos",
        "Categoria": "Procedimientos comunes OPERACIONES",
        "Url": "https://www.google.com"
      }
    ]
  }] 